import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/heektime-notice-web/heektime-notice-web/src/components/layout/layout.tsx";
import AddToAppleWatchButton from "./add-button/index.tsx";
import "./index.scss";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`HeekTime 페이스 갤러리`}</h1>
    <p>{`HeekTime에서 제공하는 컴플리케이션에 대해 알아보세요. 또는 추가 버튼을 눌러 컴플리케이션이 적용된 페이스를 바로 적용할 수도 있습니다.`}</p>
    <br />
    <h2>{`현재 강의 컴플리케이션`}</h2>
    <p>{`현재 강의 혹은 다음 강의 정보와 남은 시간을 표시합니다.`}</p>
    <div className="face-image-wrapper">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "360px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/321eb3bfd61616c7736f3399195dd055/7a322/%EB%AA%A8%EB%93%88.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "109.70588235294116%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/321eb3bfd61616c7736f3399195dd055/428d3/%EB%AA%A8%EB%93%88.avif 340w", "/static/321eb3bfd61616c7736f3399195dd055/193c9/%EB%AA%A8%EB%93%88.avif 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/avif"
              }}></source><source parentName="picture" {...{
                "srcSet": ["/static/321eb3bfd61616c7736f3399195dd055/3b4fb/%EB%AA%A8%EB%93%88.webp 340w", "/static/321eb3bfd61616c7736f3399195dd055/97ead/%EB%AA%A8%EB%93%88.webp 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/321eb3bfd61616c7736f3399195dd055/db006/%EB%AA%A8%EB%93%88.png 340w", "/static/321eb3bfd61616c7736f3399195dd055/7a322/%EB%AA%A8%EB%93%88.png 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/321eb3bfd61616c7736f3399195dd055/7a322/%EB%AA%A8%EB%93%88.png",
                "alt": "모듈",
                "title": "모듈",
                "loading": "lazy",
                "decoding": "async",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    </div>
    <AddToAppleWatchButton href="/files/모듈.watchface" className="add-button" mdxType="AddToAppleWatchButton" />
    <br />
    <div className="face-image-wrapper">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "360px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/c76da92036cb8884da3caea8082ab440/7a322/%EB%A7%8C%ED%99%94%EA%B2%BD.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "109.70588235294116%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c76da92036cb8884da3caea8082ab440/428d3/%EB%A7%8C%ED%99%94%EA%B2%BD.avif 340w", "/static/c76da92036cb8884da3caea8082ab440/193c9/%EB%A7%8C%ED%99%94%EA%B2%BD.avif 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/avif"
              }}></source><source parentName="picture" {...{
                "srcSet": ["/static/c76da92036cb8884da3caea8082ab440/3b4fb/%EB%A7%8C%ED%99%94%EA%B2%BD.webp 340w", "/static/c76da92036cb8884da3caea8082ab440/97ead/%EB%A7%8C%ED%99%94%EA%B2%BD.webp 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c76da92036cb8884da3caea8082ab440/db006/%EB%A7%8C%ED%99%94%EA%B2%BD.png 340w", "/static/c76da92036cb8884da3caea8082ab440/7a322/%EB%A7%8C%ED%99%94%EA%B2%BD.png 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c76da92036cb8884da3caea8082ab440/7a322/%EB%A7%8C%ED%99%94%EA%B2%BD.png",
                "alt": "만화경",
                "title": "만화경",
                "loading": "lazy",
                "decoding": "async",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    </div>
    <AddToAppleWatchButton href="/files/만화경.watchface" className="add-button" mdxType="AddToAppleWatchButton" />
    <br />
    <div className="face-image-wrapper">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "360px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e202cf330888cdba854c3bd2242f6144/7a322/%EC%9D%B8%ED%8F%AC%EA%B7%B8%EB%9E%98%ED%94%84.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "109.70588235294116%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e202cf330888cdba854c3bd2242f6144/428d3/%EC%9D%B8%ED%8F%AC%EA%B7%B8%EB%9E%98%ED%94%84.avif 340w", "/static/e202cf330888cdba854c3bd2242f6144/193c9/%EC%9D%B8%ED%8F%AC%EA%B7%B8%EB%9E%98%ED%94%84.avif 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/avif"
              }}></source><source parentName="picture" {...{
                "srcSet": ["/static/e202cf330888cdba854c3bd2242f6144/3b4fb/%EC%9D%B8%ED%8F%AC%EA%B7%B8%EB%9E%98%ED%94%84.webp 340w", "/static/e202cf330888cdba854c3bd2242f6144/97ead/%EC%9D%B8%ED%8F%AC%EA%B7%B8%EB%9E%98%ED%94%84.webp 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e202cf330888cdba854c3bd2242f6144/db006/%EC%9D%B8%ED%8F%AC%EA%B7%B8%EB%9E%98%ED%94%84.png 340w", "/static/e202cf330888cdba854c3bd2242f6144/7a322/%EC%9D%B8%ED%8F%AC%EA%B7%B8%EB%9E%98%ED%94%84.png 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e202cf330888cdba854c3bd2242f6144/7a322/%EC%9D%B8%ED%8F%AC%EA%B7%B8%EB%9E%98%ED%94%84.png",
                "alt": "인포그래프",
                "title": "인포그래프",
                "loading": "lazy",
                "decoding": "async",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    </div>
    <AddToAppleWatchButton href="/files/인포그래프.watchface" className="add-button" mdxType="AddToAppleWatchButton" />
    <br />
    <div className="face-image-wrapper">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "360px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/672059fcbb395fa188810d32d0e3b972/7a322/%EA%B7%B8%EB%9D%BC%EB%94%94%EC%96%B8%ED%8A%B8.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "109.70588235294116%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/672059fcbb395fa188810d32d0e3b972/428d3/%EA%B7%B8%EB%9D%BC%EB%94%94%EC%96%B8%ED%8A%B8.avif 340w", "/static/672059fcbb395fa188810d32d0e3b972/193c9/%EA%B7%B8%EB%9D%BC%EB%94%94%EC%96%B8%ED%8A%B8.avif 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/avif"
              }}></source><source parentName="picture" {...{
                "srcSet": ["/static/672059fcbb395fa188810d32d0e3b972/3b4fb/%EA%B7%B8%EB%9D%BC%EB%94%94%EC%96%B8%ED%8A%B8.webp 340w", "/static/672059fcbb395fa188810d32d0e3b972/97ead/%EA%B7%B8%EB%9D%BC%EB%94%94%EC%96%B8%ED%8A%B8.webp 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/672059fcbb395fa188810d32d0e3b972/db006/%EA%B7%B8%EB%9D%BC%EB%94%94%EC%96%B8%ED%8A%B8.png 340w", "/static/672059fcbb395fa188810d32d0e3b972/7a322/%EA%B7%B8%EB%9D%BC%EB%94%94%EC%96%B8%ED%8A%B8.png 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/672059fcbb395fa188810d32d0e3b972/7a322/%EA%B7%B8%EB%9D%BC%EB%94%94%EC%96%B8%ED%8A%B8.png",
                "alt": "그라디언트",
                "title": "그라디언트",
                "loading": "lazy",
                "decoding": "async",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    </div>
    <AddToAppleWatchButton href="/files/그라디언트.watchface" className="add-button" mdxType="AddToAppleWatchButton" />
    <br />
    <div className="face-image-wrapper">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "360px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/f4721d34e49074174dbf3dd562ed44b6/7a322/%EC%BA%98%EB%A6%AC%ED%8F%AC%EB%8B%88%EC%95%84.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "109.70588235294116%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f4721d34e49074174dbf3dd562ed44b6/428d3/%EC%BA%98%EB%A6%AC%ED%8F%AC%EB%8B%88%EC%95%84.avif 340w", "/static/f4721d34e49074174dbf3dd562ed44b6/193c9/%EC%BA%98%EB%A6%AC%ED%8F%AC%EB%8B%88%EC%95%84.avif 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/avif"
              }}></source><source parentName="picture" {...{
                "srcSet": ["/static/f4721d34e49074174dbf3dd562ed44b6/3b4fb/%EC%BA%98%EB%A6%AC%ED%8F%AC%EB%8B%88%EC%95%84.webp 340w", "/static/f4721d34e49074174dbf3dd562ed44b6/97ead/%EC%BA%98%EB%A6%AC%ED%8F%AC%EB%8B%88%EC%95%84.webp 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f4721d34e49074174dbf3dd562ed44b6/db006/%EC%BA%98%EB%A6%AC%ED%8F%AC%EB%8B%88%EC%95%84.png 340w", "/static/f4721d34e49074174dbf3dd562ed44b6/7a322/%EC%BA%98%EB%A6%AC%ED%8F%AC%EB%8B%88%EC%95%84.png 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f4721d34e49074174dbf3dd562ed44b6/7a322/%EC%BA%98%EB%A6%AC%ED%8F%AC%EB%8B%88%EC%95%84.png",
                "alt": "캘리포니아",
                "title": "캘리포니아",
                "loading": "lazy",
                "decoding": "async",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    </div>
    <AddToAppleWatchButton href="/files/캘리포니아.watchface" className="add-button" mdxType="AddToAppleWatchButton" />
    <br />
    <div className="face-image-wrapper">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "360px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/3073d551b34419a1a90f383abf849d01/7a322/%ED%94%84%EB%9D%BC%EC%9D%B4%EB%93%9C-%EC%9A%B0%EB%B8%90.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "109.70588235294116%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3073d551b34419a1a90f383abf849d01/428d3/%ED%94%84%EB%9D%BC%EC%9D%B4%EB%93%9C-%EC%9A%B0%EB%B8%90.avif 340w", "/static/3073d551b34419a1a90f383abf849d01/193c9/%ED%94%84%EB%9D%BC%EC%9D%B4%EB%93%9C-%EC%9A%B0%EB%B8%90.avif 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/avif"
              }}></source><source parentName="picture" {...{
                "srcSet": ["/static/3073d551b34419a1a90f383abf849d01/3b4fb/%ED%94%84%EB%9D%BC%EC%9D%B4%EB%93%9C-%EC%9A%B0%EB%B8%90.webp 340w", "/static/3073d551b34419a1a90f383abf849d01/97ead/%ED%94%84%EB%9D%BC%EC%9D%B4%EB%93%9C-%EC%9A%B0%EB%B8%90.webp 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3073d551b34419a1a90f383abf849d01/db006/%ED%94%84%EB%9D%BC%EC%9D%B4%EB%93%9C-%EC%9A%B0%EB%B8%90.png 340w", "/static/3073d551b34419a1a90f383abf849d01/7a322/%ED%94%84%EB%9D%BC%EC%9D%B4%EB%93%9C-%EC%9A%B0%EB%B8%90.png 360w"],
                "sizes": "(max-width: 360px) 100vw, 360px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3073d551b34419a1a90f383abf849d01/7a322/%ED%94%84%EB%9D%BC%EC%9D%B4%EB%93%9C-%EC%9A%B0%EB%B8%90.png",
                "alt": "프라이드-우븐",
                "title": "프라이드-우븐",
                "loading": "lazy",
                "decoding": "async",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    </div>
    <AddToAppleWatchButton href="/files/프라이드-우븐.watchface" className="add-button" mdxType="AddToAppleWatchButton" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      